export default "__VITE_ASSET__CB08BKTO__"